import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocAssessmentQuestionnaireItem } from 'components/Assessments/SocAssessment/types/questionnaire'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'

/**
 * Authorization subsection adapter for SOC Assessment
 * Handles authorization extraction and transformation
 */
export class AuthorizationAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const authorizationSource = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    ).at(0)

    const requestedHours = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_REQUESTED_HOURS
    ).at(0)

    return {
      [SocFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]: Array.isArray(
        authorizationSource
      )
        ? authorizationSource?.map((source) => source.reference)
        : authorizationSource?.reference,
      [SocFormField.AUTHORIZATION_REQUESTED_HOURS]: requestedHours
    }
  }

  buildFlatAnswers(): Array<{ linkId: string; value: unknown }> {
    if (!this.formDataFieldExists(SocFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE)) {
      return []
    }

    const authorizationSource = this.getFormDataField(
      SocFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    )
    return [
      {
        linkId: SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE,
        value: Array.isArray(authorizationSource)
          ? authorizationSource?.map((source) => (source ? { reference: source } : undefined))
          : authorizationSource
          ? { reference: authorizationSource }
          : undefined
      },
      {
        linkId: SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_REQUESTED_HOURS,
        value: this.getFormDataField(SocFormField.AUTHORIZATION_REQUESTED_HOURS)
      }
    ]
  }
}
